import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanFeatures } from './hooks/use-plan-features';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanFeaturesProps as Props } from './types';

export const CurrentPlanFeatures = memo(({ className }: Props) => {
  const features = usePlanFeatures();

  return (
    <Styled.Wrapper
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      className={classnames('CurrentPlanFeatures', className)}
      sx={SX.root}
    >
      {features.map((i) => (
        <Box
          key={i.text}
          display={'flex'}
          flexDirection="row"
          alignItems="center"
          gap={0.5}
          sx={{
            opacity: i.enable ? 1 : 0.5,
          }}
        >
          <Icon name="check-circle-outline" size={18} color="success.600" />
          <Typography variant="body4" fontWeight={500} color="black">
            {i.text}
          </Typography>
        </Box>
      ))}
    </Styled.Wrapper>
  );
});

CurrentPlanFeatures.displayName = 'CurrentPlanFeatures';
